import { useEffect } from 'react';
import './Overlay.css';

type OverlayProps = {
	className?: string;
	onClick?: React.MouseEventHandler<HTMLDivElement>;
	toggle?: () => void;
};
export const Overlay = ({ className, onClick, toggle }: OverlayProps) => {
	useEffect(() => {
		const close = (e: KeyboardEvent) => {
			if (e.key === 'Escape') {
				toggle && toggle();
			}
		};
		window.addEventListener('keydown', close);
		return () => window.removeEventListener('keydown', close);
	}, [toggle]);

	return <div className={`overlay ${className}`} onClick={onClick} />;
};
